import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-wallet-payment-handling',
  templateUrl: './wallet-payment-handling.component.html',
  styleUrls: ['./wallet-payment-handling.component.scss'],
})
export class WalletPaymentHandlingComponent implements OnInit {
  status: string;
  token: string;
  remark: string;
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _auth: AuthServiceLocal,
    private _matSnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this._activatedRoute.queryParams.pipe(take(1)).subscribe((res: any) => {
      this.status = res.status;
      this.token = res.token;
      this.remark = res.remark;
    });

    this.confirmPayment();
  }

  confirmPayment() {
    this._auth
      .onCheckaddToWalletStatus(this.status, this.token, this.remark)
      .subscribe((res: any) => {
        if (res?.response != 1) {
          this._matSnackBar.open(res.message, 'OKAY', { duration: 3000 });
          this._auth.getDashboardData({});
        }
      });
  }
}
